const domain = "www.inductforwork.com.au";
export const environment = {
	production: true,
	v1AppURL: `https://${domain}/area/v1`,
	siteURL: `https://${domain}`,
	apiURL: `https://${domain}/api/v2`,
	allowedDomains: [domain],
	disallowedRoutes: [],
	defaultCountryCode: "AU",
	defaultCurrencySymbol: "$",
	s3RegionDomain: "s3-ap-southeast-2.amazonaws.com",
	stripeKey: "pk_live_NOcYPDhndnXTKDkpraH3ncr3",
	countryTaxString: "+GST",
	companyName: "Induct For Work",
	cloudFrontContentURL: "https://content.ap-southeast-2.inductforwork.com",
	legalFalsificationOfDocuments:
		"Falsification of documents is a crime (CRIMES ACT 1958 - SECT 83A). Penalty: up to 10 years’ imprisonment.",
};
